export const stripUnsafeHtml = (html: string) => {
  if (typeof html !== 'string') return ''
  return html.replace(/<script>/g, '').replace(/javascript:/g, '')
}
